import assetPositionsFactory from '../positions/asset-positions-factory';

import MMInstrumentsAssetHeader from './mm-instruments-asset-header';
import MMInstrumentsPositionDetails from './mm-instruments-asset-position-details';
import MMInstrumentsPosition from './mm-instruments-position';

export default assetPositionsFactory({
  assetCategory: 'mmInstruments',
  HeaderComponent: MMInstrumentsAssetHeader,
  ExpandedRowComponent: MMInstrumentsPositionDetails,
  RowComponent: MMInstrumentsPosition,
});
